
// Returns a string of file types to allow for image uploads
// Call this function for the value of accept="..." on a file input
export default function getImageUploadAcceptedTypes() {
    const fileTypes = ["png", "jpg", "jpeg", "webp", "gif"];
    return fileTypes.map((type) => `.${type}`).join(", ");
}